document.addEventListener("DOMContentLoaded", () => {

  const section = document.getElementById("diamond-listing-section");
  if (!section) return;

  const API_URL = "https://nancy.kodllin.com/apis/api/getStockN?auth_key=upttdtcekrao";

  const loading    = document.getElementById("diamond-loading");
  const grid       = document.getElementById("diamond-grid");
  const pagination = document.getElementById("diamond-pagination");
  const filterBar  = document.getElementById("diamond-filter-bar");

  let currentPage      = 1;
  const limit          = 24;
  let totalPages       = 1;
  let allDiamonds      = [];
  let filteredDiamonds = [];

  const activeFilters = {
    shape: [], color: [], clarity: [], lab: [],
    weightMin: null, weightMax: null,
  };

  const MULTI_FIELDS = ["shape", "color", "clarity", "lab"];

  init();

  async function init() {
    loading.style.display = "block";
    loading.innerHTML     = "Loading diamonds...";

    try {
      const res   = await fetch(API_URL, { method: "POST" });
      const json  = await res.json();
      // Handle both array response and wrapped response
      allDiamonds = Array.isArray(json) ? json : (json.data || json.diamonds || json.items || []);
      console.log(`[Diamonds] Total loaded: ${allDiamonds.length}`);
      buildFilterBar();
      applyFiltersAndRender();
    } catch (err) {
      console.error("[Diamonds] Failed:", err);
      loading.innerHTML = "Failed to load diamonds. Please try again.";
    }
  }

  function applyFiltersAndRender() {
    filteredDiamonds = allDiamonds.filter(d => {
      if (activeFilters.shape.length   && !activeFilters.shape.includes(d.shape))     return false;
      if (activeFilters.color.length   && !activeFilters.color.includes(d.color))     return false;
      if (activeFilters.clarity.length && !activeFilters.clarity.includes(d.clarity)) return false;
      if (activeFilters.lab.length     && !activeFilters.lab.includes(d.lab))         return false;
      if (activeFilters.weightMin !== null && parseFloat(d.weight) < parseFloat(activeFilters.weightMin)) return false;
      if (activeFilters.weightMax !== null && parseFloat(d.weight) > parseFloat(activeFilters.weightMax)) return false;
      return true;
    });

    currentPage = 1;
    totalPages  = Math.ceil(filteredDiamonds.length / limit) || 1;
    renderPage(currentPage);
  }

  function renderPage(page) {
    currentPage        = page;
    const start        = (page - 1) * limit;
    const pageDiamonds = filteredDiamonds.slice(start, start + limit);

    grid.innerHTML       = "";
    pagination.innerHTML = "";

    if (pageDiamonds.length === 0) {
      loading.style.display = "block";
      loading.innerHTML     = "No diamonds found for the selected filters.";
      grid.style.display    = "none";
      return;
    }

    loading.style.display = "none";
    grid.style.display    = "grid";
    renderCards(pageDiamonds);
    renderPagination();
  }

  function buildFilterBar() {
    filterBar.innerHTML = "";

    const shapeOrder   = ["ROUND","OVAL","PEAR","EMERALD","MARQUISE","CUSHION","RADIANT","HEART","PRINCESS","ASSCHER"];
    const clarityOrder = ["IF","VVS1","VVS2","VS1","VS2","SI1","SI2","I1"];
    const labOrder     = ["IGI","GIA","HRD"];

    const sortArr = (arr, order) => arr.slice().sort((a, b) => {
      const ai = order.indexOf((a || "").toUpperCase());
      const bi = order.indexOf((b || "").toUpperCase());
      return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
    });

    const shapes    = [...new Set(allDiamonds.map(d => d.shape).filter(Boolean))];
    const colors    = [...new Set(allDiamonds.map(d => d.color).filter(Boolean))].sort();
    const clarities = [...new Set(allDiamonds.map(d => d.clarity).filter(Boolean))];
    const labs      = [...new Set(allDiamonds.map(d => d.lab).filter(Boolean))];
    const weights   = allDiamonds.map(d => parseFloat(d.weight)).filter(n => n > 0);
    const wMin      = weights.length ? Math.min(...weights) : 0;
    const wMax      = weights.length ? Math.max(...weights) : 30;

    if (shapes.length)
      filterBar.appendChild(createMultiDropdown("shape", "Shape", sortArr(shapes, shapeOrder)));
    filterBar.appendChild(createRangeDropdown("weight", "Carat Weight", [wMin, wMax]));
    if (colors.length)
      filterBar.appendChild(createMultiDropdown("color", "Color", colors));
    if (clarities.length)
      filterBar.appendChild(createMultiDropdown("clarity", "Clarity", sortArr(clarities, clarityOrder)));
    if (labs.length)
      filterBar.appendChild(createMultiDropdown("lab", "Lab", sortArr(labs, labOrder)));

    const clearBtn = document.createElement("button");
    clearBtn.className = "diamond-filter-clear";
    clearBtn.innerHTML = "Clear All";
    clearBtn.addEventListener("click", () => {
      MULTI_FIELDS.forEach(f => (activeFilters[f] = []));
      activeFilters.weightMin = null;
      activeFilters.weightMax = null;
      buildFilterBar();
      applyFiltersAndRender();
    });
    filterBar.appendChild(clearBtn);

    document.addEventListener("click", (e) => {
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach((dd) => {
        if (!dd.contains(e.target)) dd.classList.remove("open");
      });
    });
  }

  function renderCards(diamonds) {
    grid.innerHTML = "";
    const fallback = "https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155";

    diamonds.forEach((d) => {
      const price = parseFloat(d.totalPrice) || 0;
      const img   = d.imageLink || fallback;

      grid.insertAdjacentHTML("beforeend", `
        <div class="diamond-card" data-stock="${d.stockNo || ""}">
          <div class="diamond-image">
            <img src="${img}" alt="${d.shape || ""}" loading="lazy"
              onerror="this.onerror=null;this.src='${fallback}';">
          </div>
          <div class="diamond-info">
            <h3>${d.weight}ct ${d.shape}</h3>
            <p class="diamond-specs">
              Colour: <b>${d.color}</b> | Clarity: <b>${d.clarity}</b> | Cut: <b>${d.cut || d.polish || "-"}</b>
            </p>
            <div class="diamond-price">
              $${price.toLocaleString("en-US", {minimumFractionDigits:2, maximumFractionDigits:2})}
            </div>
            <div class="diamond-meta">
              ${d.lab ? `
                <span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 2l7 3v6c0 5-3.5 8.5-7 11-3.5-2.5-7-6-7-11V5l7-3z"/>
                  </svg>
                  ${d.lab} Certified${d.reportNo ? ` #${d.reportNo}` : ""}
                </span>` : ""}
            </div>
          </div>
        </div>
      `);
    });

    attachCardEvents();
  }

  function renderPagination() {
    pagination.innerHTML = "";
    const wrapper = document.createElement("div");
    wrapper.className = "diamond-pagination-wrapper";

    const prevBtn = document.createElement("button");
    prevBtn.className = "diamond-page-btn diamond-page-nav";
    prevBtn.innerHTML = "Prev";
    prevBtn.disabled  = currentPage === 1;
    prevBtn.addEventListener("click", () => { if (currentPage > 1) renderPage(currentPage - 1); });
    wrapper.appendChild(prevBtn);

    getPageList(currentPage, totalPages).forEach((p) => {
      if (p === "...") {
        const dots = document.createElement("span");
        dots.className = "diamond-page-dots";
        dots.innerHTML = "&hellip;";
        wrapper.appendChild(dots);
        return;
      }
      const btn = document.createElement("button");
      btn.className = "diamond-page-btn";
      btn.innerHTML = p;
      if (p === currentPage) btn.classList.add("active");
      btn.addEventListener("click", () => { if (p !== currentPage) renderPage(p); });
      wrapper.appendChild(btn);
    });

    const nextBtn = document.createElement("button");
    nextBtn.className = "diamond-page-btn diamond-page-nav";
    nextBtn.innerHTML = "Next";
    nextBtn.disabled  = currentPage >= totalPages;
    nextBtn.addEventListener("click", () => { if (currentPage < totalPages) renderPage(currentPage + 1); });
    wrapper.appendChild(nextBtn);

    pagination.appendChild(wrapper);
  }

  function getPageList(current, total) {
    const pages = [];
    if (total <= 7) { for (let i = 1; i <= total; i++) pages.push(i); return pages; }
    pages.push(1);
    if (current > 3) pages.push("...");
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
    if (current < total - 2) pages.push("...");
    pages.push(total);
    return pages;
  }

  function attachCardEvents() {
    document.querySelectorAll(".diamond-card").forEach((card) => {
      card.addEventListener("click", () => {
        const stock = card.dataset.stock;
        if (!stock) return;
        const diamond = filteredDiamonds.find(d => d.stockNo === stock);
        if (diamond) {
          try { sessionStorage.setItem("diamond_" + stock, JSON.stringify(diamond)); } catch(e) {}
        }
        window.location.href = `/pages/diamond-detail?stock=${encodeURIComponent(stock)}`;
      });
    });
  }

  function createMultiDropdown(field, label, values) {
    const dropdown = document.createElement("div");
    dropdown.className = "diamond-filter-dropdown";
    const count = activeFilters[field].length;
    const btn   = document.createElement("button");
    btn.className = "diamond-filter-btn" + (count > 0 ? " has-value" : "");
    btn.innerHTML = `${label}${count > 0 ? ` (${count})` : ""} <span class="arrow">&#9662;</span>`;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains("open");
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach(dd => dd.classList.remove("open"));
      if (!wasOpen) dropdown.classList.add("open");
    });
    const panel = document.createElement("div");
    panel.className = "diamond-filter-panel";
    values.forEach((val) => {
      const row = document.createElement("label");
      row.className = "diamond-filter-checkbox-row";
      const cb = document.createElement("input");
      cb.type = "checkbox"; cb.value = val;
      cb.checked = activeFilters[field].includes(val);
      cb.addEventListener("change", () => {
        if (cb.checked) activeFilters[field].push(val);
        else activeFilters[field] = activeFilters[field].filter(v => v !== val);
        btn.className = "diamond-filter-btn" + (activeFilters[field].length > 0 ? " has-value" : "");
        btn.innerHTML = `${label}${activeFilters[field].length > 0 ? ` (${activeFilters[field].length})` : ""} <span class="arrow">&#9662;</span>`;
        applyFiltersAndRender();
      });
      row.appendChild(cb);
      row.appendChild(document.createTextNode(val));
      panel.appendChild(row);
    });
    dropdown.appendChild(btn);
    dropdown.appendChild(panel);
    return dropdown;
  }

  function createRangeDropdown(key, label, defaults) {
    const [defMin, defMax] = defaults;
    const dropdown = document.createElement("div");
    dropdown.className = "diamond-filter-dropdown";
    const hasValue = activeFilters[`${key}Min`] !== null || activeFilters[`${key}Max`] !== null;
    const btn = document.createElement("button");
    btn.className = "diamond-filter-btn" + (hasValue ? " has-value" : "");
    btn.innerHTML = `${label} <span class="arrow">&#9662;</span>`;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains("open");
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach(dd => dd.classList.remove("open"));
      if (!wasOpen) dropdown.classList.add("open");
    });
    const panel = document.createElement("div");
    panel.className = "diamond-filter-panel";
    const row = document.createElement("div");
    row.className = "diamond-filter-range-row";
    const minInput = document.createElement("input");
    minInput.type = "number"; minInput.step = "0.01";
    minInput.placeholder = `Min (${defMin})`;
    minInput.value = activeFilters[`${key}Min`] ?? "";
    const dash = document.createElement("span");
    dash.innerHTML = "&ndash;";
    const maxInput = document.createElement("input");
    maxInput.type = "number"; maxInput.step = "0.01";
    maxInput.placeholder = `Max (${defMax})`;
    maxInput.value = activeFilters[`${key}Max`] ?? "";
    const applyBtn = document.createElement("button");
    applyBtn.className = "diamond-filter-apply-btn";
    applyBtn.innerHTML = "Apply";
    applyBtn.addEventListener("click", () => {
      activeFilters[`${key}Min`] = minInput.value !== "" ? minInput.value : null;
      activeFilters[`${key}Max`] = maxInput.value !== "" ? maxInput.value : null;
      btn.className = "diamond-filter-btn" + (activeFilters[`${key}Min`] !== null || activeFilters[`${key}Max`] !== null ? " has-value" : "");
      dropdown.classList.remove("open");
      applyFiltersAndRender();
    });
    row.appendChild(minInput); row.appendChild(dash); row.appendChild(maxInput);
    panel.appendChild(row); panel.appendChild(applyBtn);
    dropdown.appendChild(btn); dropdown.appendChild(panel);
    return dropdown;
  }

});
